import type { en } from './en';

// Russian translations. Keys must match en.ts; missing keys fall back to en.
export const ru: typeof en = {
  // Connecting / route
  'connecting': 'Подключение…',
  'joiningRoom': 'Подключение к комнате {code}…',
  'disconnected': 'отключено — переподключаемся…',

  // Time
  'time.justNow': 'только что',
  'time.minutesAgo': '{n} мин назад',
  'time.hoursAgo': '{n} ч назад',

  // Room types
  'type.games': 'Игры',
  'type.movies': 'Фильмы',
  'type.anime': 'Аниме',

  // Home page
  'home.title': '🎲 Совершенно Беспристрастный Рандомайзер',
  'home.subtitle': 'Создай комнату, поделись кодом — колесо решит.',
  'home.create': 'Создать комнату',
  'home.titleLabel': 'Название',
  'home.titlePlaceholder': 'Пятничный игровой вечер',
  'home.typeLabel': 'Тип',
  'home.listed': 'Публичная комната',
  'home.listedHint': '(при отключении доступ только по ссылке)',
  'home.createButton': 'Создать комнату',
  'home.titleRequired': 'Нужно название',
  'home.activeRooms': 'Активные комнаты',
  'home.codePlaceholder': 'Код комнаты',
  'home.join': 'Войти',
  'home.loading': 'загружаем комнаты…',
  'home.noRooms': 'Публичных комнат пока нет — создай первую!',
  'home.players_one': '{n} игрок',
  'home.players_few': '{n} игрока',
  'home.players_many': '{n} игроков',

  // Room — header
  'room.back': '← На главную',
  'room.backTitle': 'Обратно к списку комнат',
  'room.nameLabel': 'Имя',
  'room.namePlaceholder': 'Игрок',

  // Room — participant card
  'room.you': '(ты)',
  'room.statusReady': '✓ готов',
  'room.statusPicking': '…выбирает',
  'room.statusDisconnected': 'отключён',
  'room.joining': 'присоединяется…',
  'room.noPicks': 'пока ничего не выбрано',

  // Room — action buttons
  'room.selectAll': 'Выбрать всё',
  'room.deselectAll': 'Снять всё',
  'room.preset': 'Пресет',
  'room.presetTitle': 'Применить пресет',
  'room.save': 'Сохранить',
  'room.saveTitle': 'Сохранить пресет',
  'room.presetSaved': 'Пресет сохранён ({n})',
  'room.ready': 'Готов',
  'room.cancelReady': 'Отменить',

  // Room — picks summary (slot {n} = picks count, {h} = hearted count)
  'room.pickedSummary_games': 'Выбрано: {n} · {h}/1 ♥',
  'room.pickedSummary_movies': 'Выбрано: {n} · {h}/1 ♥',
  'room.pickedSummary_anime': 'Выбрано: {n} · {h}/1 ♥',

  // Room — heart button
  'room.heart.remove': 'Уже не так хочу',
  'room.heart.move': 'Хочу сильнее',
  'room.heart.add': 'Сильно хочу',

  // Room — custom add
  'room.customPlaceholder.games': 'Добавить свои игры — по одной в строке',
  'room.customPlaceholder.movies': 'Добавить свои фильмы — по одному в строке',
  'room.customPlaceholder.anime': 'Добавить свои тайтлы — по одному в строке',
  'room.add': 'Добавить',
  'room.removeCustom': 'Удалить добавленное',

  // Room — vetoed/master list
  'room.master': 'Общий список',
  'room.masterEmpty': 'Пока ничего',
  'room.vetoed': 'Заблокированные',
  'room.vetoedBy': 'от {name}',
  'room.undo': 'Вернуть',
  'room.undoTitle': 'Вернуть в пул и освободить твоё вето',
  'room.footerStatus': '{ready}/{total} готовы · {pool} в розыгрыше',
  'room.outLabel': 'нет',

  // Room — downvote button
  'room.dv.remove': 'Убрать минус',
  'room.dv.grayedOut': 'Уже отключено двумя игроками',
  'room.dv.title': 'Не хочу ({n}/2)',

  // Room — vetoed game tooltip suffix
  'room.tile.vetoed': '{name} (заблокировано)',

  // Room — countdown / wheel / result
  'room.spinning': 'Крутим…',
  'room.eyebrow.games': 'сегодня играем в',
  'room.eyebrow.movies': 'сегодня смотрим',
  'room.eyebrow.anime': 'сегодня смотрим',
  'room.startNew': 'Начать новый раунд',
  'room.vetoUsed': 'Вето использовано',
  'room.vetoButton': 'Вето (1 в раунде)',
  'room.vetoTitle': 'Убирает эту игру и крутит заново',
  'room.vetoConfirm': 'Заблокировать «{name}»? Это потратит вето в этой сессии.',
  'room.requestRespin': 'Запросить респин',
  'room.respinTitle': 'Все игроки должны согласиться',
  'room.respinStatus': 'Перекрутка: {voted}/{total} согласны',
  'room.respinYes': 'Да, респин',
  'room.respinNo': 'Нет, оставить',
  'room.respinWaiting': 'Ждём остальных…',

  // Admin shortcut in room header
  'room.admin.reset': '🛠️ Сброс',
  'room.admin.resetTitle': 'Админ: сбросить эту комнату',
  'room.admin.resetConfirm': 'Сбросить комнату {code}? Все выборы/голосования/вето очистятся.',
  'room.admin.resetDone': 'Комната сброшена',
  'room.admin.resetFail': 'Сброс не удался: {status}',

  // Admin page
  'admin.signIn': 'Вход для админа',
  'admin.signInHint': 'Вставь админ-токен, чтобы управлять каталогами и комнатами.',
  'admin.tokenPlaceholder': 'Токен',
  'admin.signInButton': 'Войти',
  'admin.invalidToken': 'Неверный токен',
  'admin.authFailed': 'Авторизация не прошла ({status})',
  'admin.networkError': 'Ошибка сети: {message}',
  'admin.tokenRejected': 'Токен отклонён — войди заново.',
  'admin.title': '🛠️ Админ',
  'admin.refresh': '↻ Обновить',
  'admin.signOut': 'Выйти',
  'admin.catalogs': 'Каталоги',
  'admin.loading': 'Загрузка…',
  'admin.noData': 'Пока нет данных.',
  'admin.upload': 'Загрузить логотипы',
  'admin.uploadHint': 'PNG / SVG / WebP / AVIF / JPG (≤5 МБ). Имя файла станет отображаемым названием.',
  'admin.noLogos': 'Логотипов пока нет. Загрузи их выше.',
  'admin.delete': 'Удалить',
  'admin.deleteLogoConfirm': 'Удалить {filename}? Активные комнаты типа «{type}» сразу потеряют этот логотип.',
  'admin.deletedLogo': '{filename} удалён',
  'admin.deleteLogoFail': 'Не удалось удалить: {detail}',
  'admin.uploadedLogo': '{filename} загружен',
  'admin.uploadFail': 'Не удалось загрузить: {detail}',
  'admin.activeRooms': 'Активные комнаты',
  'admin.loadingRooms': 'Загружаем комнаты…',
  'admin.noActiveRooms': 'Активных комнат нет.',
  'admin.open': 'Открыть',
  'admin.reset': 'Сброс',
  'admin.resetConfirm': 'Сбросить «{title}» ({code})? Все выборы/голосования/вето очистятся.',
  'admin.resetDone': '{code} сброшена',
  'admin.resetFail': 'Сброс не удался: {status}',
  'admin.deleteRoomConfirm': 'Удалить «{title}» ({code})? Все игроки вернутся на главную.',
  'admin.deletedRoom': '{code} удалена',
  'admin.deleteRoomFail': 'Не удалось удалить: {status}',
  'admin.listed': 'публичная',
  'admin.unlisted': 'скрытая',
  'admin.catalogFetchFail': 'Не удалось загрузить каталог: {message}',
  'admin.roomsFetchFail': 'Не удалось загрузить комнаты: {message}',
};
